import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import useBreadCrumbsStorage from '../hooks/localStorage/useBreadCrumbsStorage';
import { useConfigPathContext } from './ConfigPathContextProvider';
import { getFolderName } from '../hooks/useConfigsNavigator';
import useControlBarStorage from '../hooks/localStorage/useControlBarStorage';

const BreadCrumbsContext = createContext();

export default function BreadCrumbsContextProvider({children}) {
  const {breadCrumbs:crumbsStorage, setBreadCrumbs:setCrumbsStorge} = useBreadCrumbsStorage();
  const [configCrumbs, setConfigCrumbs]                             = useState(crumbsStorage?.config);
  const {configPath}                                                = useConfigPathContext();
  const {controlBar, setControlBar}                                 = useControlBarStorage();

  // Effect - On Explicit setConfigCrumbs - update the "config" block in the breadcrumbs object
  useEffect(()=>{
    if (configCrumbs) {
      setCrumbsStorge(prev => ({...prev, config: configCrumbs}));
    }
  }, [configCrumbs, setCrumbsStorge]);

  // Effect - On Every configPath change, update configCrumbs
  useEffect(()=>{
    if (configPath) {
      //console.log('[BreadCrumbsContextProvider Effect] [configPath: %s]', configPath);      
      setConfigCrumbs(prev => ({...prev, [configPath]:getFolderName(configPath)}));
    }
  }, [configPath]);

  // Memoized Value
  // 
  const memoizedValue = useMemo(()=>({
    configCrumbs,
    setConfigCrumbs,
    controlBar, setControlBar
  }), [configCrumbs, setConfigCrumbs, controlBar, setControlBar]);

  return (
    <BreadCrumbsContext.Provider value={memoizedValue}>
      {children}
    </BreadCrumbsContext.Provider>
  )
}


export function useBreadCrumbsContext() {
  return useContext(BreadCrumbsContext);
}